import { FC, MouseEvent } from 'react';
import { Typography } from '@mui/material';

import { ChevronRightIcon } from '../../icons';

import {
	StyledMplTicketCard,
	StyledMplTicketCardChevron,
	StyledMplTicketCardContent,
} from './MplTicketCard.styled';

export interface IMplTicketCardProps {
	title: string;
	subtitle: string;
	onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
	dataTestId?: string;
}

export const MplTicketCard: FC<IMplTicketCardProps> = ({
	title,
	subtitle,
	onClick,
	dataTestId,
}) => {
	return (
		<StyledMplTicketCard onClick={onClick} data-testid={dataTestId}>
			<StyledMplTicketCardContent>
				<Typography
					variant="b2-m"
					color="primary.main"
					sx={{
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
					}}
				>
					{title}
				</Typography>
				<Typography variant="l1" color="solutions.600">
					{subtitle}
				</Typography>
			</StyledMplTicketCardContent>
			<StyledMplTicketCardChevron>
				<ChevronRightIcon />
			</StyledMplTicketCardChevron>
		</StyledMplTicketCard>
	);
};
